import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter
} from '@jutro/components';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import messages from 'sg-common-messages';

function SgModalCtrl(props) {
    const {
        title,
        closeBtnLabel,
        isOpen,
        onResolve,
        className,
        modalMetadata,
        modalJsx,
        titleVisibility,
        onCancel,
        onConfirm,
        shouldDisableCloseButton
    } = props;

    const btnLabel = _.isEmpty(closeBtnLabel) ? messages.ModalMessageClose : closeBtnLabel;
    const visible = _.isEmpty(titleVisibility) ? titleVisibility : !titleVisibility;

    const overrideProps = {
    };
    const resolvers = {
        resolveComponentMap: {
        }
    };

    return (
        <ModalNext isOpen={isOpen}>
            <div className={className}>
                <ModalHeader
                    title={visible && title}
                    onClose={onCancel || onResolve}
                />
                <ModalBody
                    contentLayout={{
                        component: 'div'
                    }}
                >
                    {
                        (modalMetadata !== undefined
                            ? renderContentFromMetadata(modalMetadata.componentContent, overrideProps, resolvers)
                            : modalJsx)
                    }

                </ModalBody>
                <ModalFooter>
                    <Button
                        disabled={shouldDisableCloseButton}
                        onClick={onConfirm || onResolve}
                        id="modalCloseButton"
                        className="sgSecondaryBlueButton"
                    >
                        {btnLabel}
                    </Button>
                </ModalFooter>
            </div>
        </ModalNext>

    );
}

SgModalCtrl.propTypes = {
    title: PropTypes.string.isRequired,
    closeBtnLabel: PropTypes.shape({}),
    isOpen: PropTypes.bool.isRequired,
    onResolve: PropTypes.func.isRequired
};

SgModalCtrl.defaultProps = {
    closeBtnLabel: messages.ModalMessageClose
};

export default SgModalCtrl;
